import React, { useEffect, useState } from "react";
import BaseModal from "../BaseModal";
import PatientName from "../Common/PatientName";
import TextArea from "../Common/TextArea";
import Button from "../../Buttons/Button";
import Edit from "../../../../Assets/Icons/Edit.png";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import "react-datepicker/dist/react-datepicker-cssmodules.css";
import "./style.css";
// import CustomDatePicker from "../../CustomDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import CustomCalendarIcon from './CustomCalendarIcon'; // Import your custom icon component
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import Dropdown from "../../Dropdown";
import { usePatientContext } from "../../../../Context/PatientContext";
import { getAge, getDDMMYY, getDOB } from "../../../../Helpers";
import { editPatientDetails, getCuratedFilesList } from "../../../../Services";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../../Context/AuthContext";
import ViewReportModal from "../viewReportModal";
import Input from "../../Input";
import FlyerMessage from "../../FlyerMessage";
import dayjs from "dayjs";

const calendarCustomStyle = {
  ".MuiDateCalendar-root": {
    height: "100%",
    fontSize: "10px",
  },
  ".MuiDateCalendar-root button": {
    fontSize: "14px",
    padding: 0,
    margin: 0,
  },
  ".MuiDateCalendar-root .MuiPickersCalendarHeader-label": {
    fontSize: "14px",
    padding: 0,
    margin: 0,
  },
};

/**
 * Modal for editing patient details
 * @param {function} onClose - Function to handle the modal close event
 * @param {object} patientInfo - Information about the patient
 */
const EditPatientModal = ({ type, onClose, patientSummary }) => {
  const modalTitleMap = {
    profile: "Edit Patient Details",
    summary: "Edit Patient Summary",
  };
  const flyerMessageMap = {
    profile: "Patient details edited successfully!",
    summary: "Patient summary edited successfully!",
  };
  const { patientId } = useParams(); /* Read dynamic URL params */
  const { physician } = useAuth();
  const { patientDetails, updatePatientDetails } = usePatientContext();

  // State to manage the visit date & notes
  const [editPatient, setEditPatient] = useState({
    firstName: patientDetails.firstName,
    lastName: patientDetails.lastName,
    dateOfBirth: patientDetails.dateOfBirth,
    gender: patientDetails.gender,
  });
  const [editPatientSummaryData, setEditPatientSummaryData] =
    useState(patientSummary);
  const [isRecordUpdated, setIsRecordUpdated] = useState(false);
  const [isEditAge, setIsEditAge] = useState({ age: false, dob: false });
  const [isViewReportModalOpen, setViewReportModalOpen] = useState(false);
  const [recordURL, setRecordURL] = useState(null);
  const [selectedReport, setSelectedReport] = useState(null);
  const [selectedReportDetails, setSelectedReportDetails] = useState({});
  const [summaryOpenReportModalError, setSummaryOpenReportModalError] =
    useState(false);

  // console.log(new Date(editPatientSummaryData["dateofDiagnosis"]["value"]));

  const handleSave = async (event) => {
    try {
      // set payload according to edit type
      const payload =
        type === "profile"
          ? { updates: editPatient }
          : {
              updates: {
                diagnosis: {
                  location: editPatientSummaryData?.location?.text,
                  cancerType: editPatientSummaryData?.cancerType?.text,
                  histologicalSubtype:
                    editPatientSummaryData?.histologicalSubtype?.text,
                  dateofDiagnosis:
                    editPatientSummaryData?.dateofDiagnosis?.value,
                  // additionalInfo: editPatientSummaryData?.additionalInfo?.text,
                },
              },
            };
      // call edit API
      const editResponse = await editPatientDetails(
        physician.physician._id,
        patientId,
        payload
      );
      if (!editResponse.error) {
        updatePatientDetails({ ...patientDetails, ...editResponse.data });
      }

      setIsRecordUpdated(true); // Set the state to show FlyerMessage with the messageType
    } catch (error) {}
  };

  // update edit summary data when patientDetails updates
  useEffect(() => {
    const cancerInfo = [
      // {
      //   id: 1,
      //   label: "Histology Subtype",
      //   text: patientDetails?.diagnosis?.histologicalSubtype,
      //   fileid: patientDetails?.diagnosis?.recordURL,
      // },
      {
        id: 2,
        label:
          patientDetails?.tumorCharacterisation?.length > 0 &&
          patientDetails?.tumorCharacterisation[
            patientDetails?.tumorCharacterisation?.length - 1
          ]?.description &&
          "Tumor size",
        text:
          patientDetails?.tumorCharacterisation?.length > 0 &&
          patientDetails?.tumorCharacterisation[
            patientDetails?.tumorCharacterisation?.length - 1
          ]?.description,
        fileid:
          patientDetails?.tumorCharacterisation?.length > 0 &&
          patientDetails?.tumorCharacterisation[
            patientDetails?.tumorCharacterisation?.length - 1
          ]?.recordURL,
      },
      {
        id: 3,
        label:
          patientDetails?.genomicFindings?.length > 0 &&
          patientDetails?.genomicFindings[
            patientDetails?.genomicFindings?.length - 1
          ]?.name &&
          "Molecular Mutation",
        text:
          patientDetails?.genomicFindings?.length > 0 &&
          patientDetails?.genomicFindings[
            patientDetails?.genomicFindings?.length - 1
          ]?.name,
        fileid:
          patientDetails?.genomicFindings?.length > 0 &&
          patientDetails?.genomicFindings[
            patientDetails?.genomicFindings?.length - 1
          ]?.recordURL,
      },
      {
        id: 4,
        label:
          patientDetails?.biomarkerFindings?.length > 0 &&
          patientDetails?.biomarkerFindings[
            patientDetails?.biomarkerFindings?.length - 1
          ]?.name &&
          "Biomarker",
        text:
          patientDetails?.biomarkerFindings?.length > 0 &&
          patientDetails?.biomarkerFindings[
            patientDetails?.biomarkerFindings?.length - 1
          ]?.name,
        fileid:
          patientDetails?.biomarkerFindings?.length > 0 &&
          patientDetails?.biomarkerFindings[
            patientDetails?.biomarkerFindings?.length - 1
          ]?.recordURL,
      },
    ];
    setEditPatientSummaryData({
      dateofDiagnosis: {
        label: "Diagnosis Date",
        text: getDDMMYY(patientDetails?.diagnosis?.dateofDiagnosis),
        value: patientDetails?.diagnosis?.dateofDiagnosis,
        fileid: patientDetails?.diagnosis?.recordURL,
      },
      location: {
        label: "Location",
        text: patientDetails?.diagnosis?.location,
        fileid: patientDetails?.diagnosis?.recordURL,
      },
      cancerType: {
        label: "Cancer Type",
        text: patientDetails?.diagnosis?.cancerType,
        fileid: patientDetails?.diagnosis?.recordURL,
      },
      histologicalSubtype: {
        label: "Histology Subtype",
        text: patientDetails?.diagnosis?.histologicalSubtype,
        fileid: patientDetails?.diagnosis?.recordURL,
      },
      stage: {
        label: "Stage",
        text:
          (patientDetails?.staging?.length > 0 &&
            patientDetails?.staging[patientDetails?.staging?.length - 1]
              ?.stage) ||
          "",
        fileid:
          patientDetails?.staging?.length > 0 &&
          patientDetails?.staging[patientDetails?.staging?.length - 1]
            ?.recordURL,
      },
      cancerInfo: cancerInfo,
    });
  }, [patientDetails]);

  // console.log(editPatientSummaryData);

  const handleSummaryEdit = async (fileid) => {
    // Get the url from the key using lambda function api
    try {
      const selectedReportDetailsResponse = await getCuratedFilesList(
        physician.physician._id,
        patientId,
        fileid
      );

      if (!selectedReportDetailsResponse.error) {
        setSelectedReportDetails(
          selectedReportDetailsResponse?.data?.fieldDetails
        );
        let clickedInvestigation =
          selectedReportDetailsResponse?.data?.curatedFiles[0];
        // console.log(clickedInvestigation, "clicked report");

        const getLink = await fetch(
          "https://0t38n05kd3.execute-api.ap-south-1.amazonaws.com/default/presigned_url",
          {
            method: "POST",
            body: JSON.stringify({
              bucket: process.env.REACT_APP_AWS_BUCKET_NAME,
              report_key_array: [clickedInvestigation.key],
            }),
          }
        );
        const link = await getLink.json();
        setRecordURL(link?.presigned_url_array[0]);
        setSelectedReport(clickedInvestigation);

        // Open the modal with the recordURL
        setViewReportModalOpen(true);
      }
    } catch (error) {
      setSummaryOpenReportModalError(true);
    }
  };

  // Event handler for when the user clicks the "Close" button on FlyerMessage
  const handleFlyerMessageClose = () => {
    onClose();
    // Reset the state to hide FlyerMessage
    setIsRecordUpdated(false);
  };

  return (
    //Reusable components - BaseModal, PatientName, TextArea, Button for add file, record audio and send  - pass props accordingly
    <BaseModal
      title={modalTitleMap[type]}
      onClose={onClose}
      showFlyerMessage={isRecordUpdated}
      flyerMessageText={flyerMessageMap[type]}
      onFlyerMessageClose={handleFlyerMessageClose}
    >
      <div className="edit-patient-details-container">
        <h6 className="h6-500">Patient ID: {patientDetails.patientId}</h6>
        {type === "profile" && (
          <div className="edit-patient-details-frame">
            <div className="details-input-frame">
              <div className="input-frame">
                <p className="p-500 dark-grey">Name</p>
                <div style={{ display: "flex", gap: "7px" }}>
                  <Input
                    type="text"
                    value={editPatient.firstName}
                    onChange={(e) =>
                      setEditPatient({
                        ...editPatient,
                        firstName: e.target.value,
                      })
                    }
                    placeholder="First Name"
                  />
                  <Input
                    type="text"
                    value={editPatient.lastName}
                    onChange={(e) =>
                      setEditPatient({
                        ...editPatient,
                        lastName: e.target.value,
                      })
                    }
                    placeholder="Last Name"
                  />
                </div>
              </div>
              <div className="input-frame">
                <div style={{ display: "flex", gap: "7px" }}>
                  <p className="p-500 dark-grey">Age</p>
                  <p>{getAge(editPatient.dateOfBirth)}</p>
                </div>

                <div
                  style={{ display: "flex", gap: "7px", width: "100%" }}
                  id="patient-details-calendar"
                >
                  {!isEditAge.dob ? (
                    <Button
                      btnType="grey"
                      text="Enter Date Of Birth"
                      onClick={() => {
                        setIsEditAge({ dob: true, age: false });
                      }}
                      style={{ padding: "16px 10px", flex: "1 1 0" }}
                    />
                  ) : (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        //   className={styles.date_picker2}
                        format="DD/MM/YYYY"
                        slots={{ openPickerIcon: UnfoldMoreIcon }}
                        selected={
                          !editPatient["dateOfBirth"]
                            ? new Date()
                            : new Date(editPatient["dateOfBirth"])
                        }
                        onChange={(date) =>
                          setEditPatient({ ...editPatient, dateOfBirth: date })
                        }
                        slotProps={{
                          // textField: { size: "small" },
                          popper: {
                            sx: calendarCustomStyle,
                          },
                        }}
                        placeholder="Date of Birth"
                      />
                    </LocalizationProvider>
                  )}
                  {!isEditAge.age ? (
                    <Button
                      btnType={"grey"}
                      text={"Enter Age"}
                      onClick={() => {
                        setIsEditAge({ dob: false, age: true });
                      }}
                      style={{ padding: "16px 10px", flex: "1 1 0" }}
                    />
                  ) : (
                    <Input
                      name="age"
                      value={getAge(editPatient["dateOfBirth"])}
                      onChange={(e) =>
                        setEditPatient({
                          ...editPatient,
                          dateOfBirth: getDOB(e.target.value),
                        })
                      }
                      type="text"
                    />
                  )}
                </div>
              </div>
              <div className="input-frame">
                <p className="p-500 dark-grey">Gender</p>
                <div style={{ width: "50%" }}>
                  <Dropdown
                    options={["Male", "Female", "Other"]}
                    selectedOption={editPatient.gender}
                    onSelect={(option) =>
                      setEditPatient({ ...editPatient, gender: option })
                    }
                    boxStyle={{
                      backgroundColor: "#f8f8f8",
                      padding: "16px 10px",
                      width: "90%",
                    }}
                    listStyle={{ top: "50px", width: "90%" }}
                  />
                </div>
              </div>
            </div>
            <div className="details-button-frame">
              <Button btnType="save" onClick={handleSave} />
              <Button btnType="cancelWithIconAtFront" onClick={onClose} />
            </div>
          </div>
        )}
        {type === "summary" && (
          <div className="details-frame">
            {Object.keys(editPatientSummaryData).map((type, index) => {
              if (type === "stage") {
                return (
                  <div key={index} className="input-frame">
                    <p className="p-500 dark-grey">
                      {editPatientSummaryData[type]["label"]}: {"  "}
                      {editPatientSummaryData[type]["text"] && (
                        <img
                          className="edit-item-icon"
                          alt="edit-icon"
                          src={Edit}
                          onClick={async () => {
                            if (
                              editPatientSummaryData[type] &&
                              editPatientSummaryData[type]["fileid"]
                            ) {
                              await handleSummaryEdit(
                                editPatientSummaryData[type]["fileid"]
                              );
                            }
                          }}
                        />
                      )}
                    </p>
                    <div
                      className="dark-grey input-box"
                      style={{ boxSizing: "border-box", width: "100%" }}
                    >
                      <p>{` ${editPatientSummaryData[type]["text"]}`}</p>
                    </div>
                  </div>
                );
              } else if (type !== "cancerInfo") {
                return (
                  <div key={index} className="input-frame">
                    <p className="p-500 dark-grey">
                      {editPatientSummaryData[type]["label"]}: {"  "}
                    </p>
                    {type === "dateofDiagnosis" ? (
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          format="DD/MM/YYYY"
                          slots={{ openPickerIcon: UnfoldMoreIcon }}
                          // selected={
                          // !editPatientSummaryData["dateofDiagnosis"]["value"]
                          //   ? new Date()
                          //   : new Date(
                          //       editPatientSummaryData["dateofDiagnosis"][
                          //         "value"
                          //       ]
                          //     )
                          // }
                          value={dayjs(
                            editPatientSummaryData["dateofDiagnosis"]["value"]
                          )}
                          onChange={(date) =>
                            setEditPatientSummaryData({
                              ...editPatientSummaryData,
                              [type]: {
                                ...editPatientSummaryData[type],
                                text: date,
                                value: date,
                              },
                            })
                          }
                          slotProps={{
                            popper: {
                              sx: calendarCustomStyle,
                            },
                          }}
                          placeholder="Date of Diagnosis"
                        />
                      </LocalizationProvider>
                    ) : (
                      <Input
                        type="text"
                        value={editPatientSummaryData[type]["text"]}
                        onChange={(e) =>
                          setEditPatientSummaryData({
                            ...editPatientSummaryData,
                            [type]: {
                              ...editPatientSummaryData[type],
                              text: e.target.value,
                            },
                          })
                        }
                        placeholder={editPatientSummaryData[type]["label"]}
                      />
                    )}
                  </div>
                );
              }
            })}
            <div className="details-button-frame">
              <Button btnType="save" onClick={handleSave} />
              <Button btnType="cancelWithIconAtFront" onClick={onClose} />
            </div>
          </div>
        )}
      </div>

      {/* Show Edit Record Modal when delete button in the table is clicked*/}
      {isViewReportModalOpen && (
        <ViewReportModal
          screen={"table"}
          type={"edit"}
          report={selectedReport}
          reportURL={recordURL}
          onClose={() => setViewReportModalOpen(false)}
          fields={selectedReportDetails}
          patientId={patientId}
          physicianId={physician.physician._id}
        />
      )}
      {/* Show error Flyer message */}
      {summaryOpenReportModalError && (
        <FlyerMessage
          message="The file is not available for editing"
          onClose={() => setSummaryOpenReportModalError(false)}
        />
      )}
    </BaseModal>
  );
};

export default EditPatientModal;
